import { useEffect, useState } from "react"
import { useCentralStore } from "../../store/appContext"
import CVMData from './CustomerValueManagement'
import GlossaryReportCVM from "./GlossaryReportCVM"

const SLAReportContainer = () => {

    const [ { carrierThemeData, projectName, selectedTab }, dispatch ] = useCentralStore()
    const { theme } = carrierThemeData;
    return(
        <div>
            {projectName === "Customer Value Management" && selectedTab === 'Chart' &&
                <CVMData/>
            }
            {projectName === "Customer Value Management" && selectedTab ==="Glossary" &&
                <GlossaryReportCVM selectedTab={selectedTab} projectName={projectName} theme={theme} />
            }
           
        </div>
    )
}

export default SLAReportContainer